module.exports = __webpack_public_path__ + "static/img/consultingCenter_3.495bdca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/consultingCenter_3.png
// module id = Ke4l
// module chunks = 1